exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".language-select {\n  color: var(--primary-background-color);\n  display: block;\n  min-width: 150px;\n}\n", ""]);
